import { UserPermissions } from '@centecomm/portal-service';
import InvoicesNavigationIcon from 'Icons/NavigationItem/Invoices';
import React from 'react';
import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import TenantRoot from './TenantRoot';

const invoicesConfiguration: FeatureConfiguration = {
    name: 'common:sidebar.featureInvoicesTitle',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureInvoicesTitle',
            url: '/invoices',
            Icon: InvoicesNavigationIcon,
            ownerOperatorRoot: null,
            tenantRoot: <TenantRoot />,
        },
        permissions: [UserPermissions.ViewInvoices],
    },
    disableFeature: [],
};

export default invoicesConfiguration;
